export default __webpack_public_path__ + "images/lubriderm_logo.png";